import React from 'react'
import { useDispatch } from 'react-redux'

import InternalEffectPanel from '@/pages/getRecipe/internalEffects/InternalEffectPanel'
import { useAppSelector } from '@/store'
import {
  setInternalEffectCeramicBrand,
  setSelectedInternalEffect,
} from '@/store/pfmCrown'

function PfmCrownInternalEffectPanel({
  containerRef,
}: {
  containerRef: React.RefObject<HTMLDivElement>
}) {
  const dispatch = useDispatch()
  const ceramicBrand = useAppSelector(
    (state) => state.pfmCrown.internalEffectCeramicBrand,
  )
  const selectedInternalEffect = useAppSelector(
    (state) => state.pfmCrown.selectedInternalEffect,
  )

  return (
    <InternalEffectPanel
      containerRef={containerRef}
      ceramicBrand={ceramicBrand}
      selectedInternalEffect={selectedInternalEffect}
      onCeramicBrandChange={(value) =>
        dispatch(setInternalEffectCeramicBrand(value))
      }
      onSelectedInternalEffectChange={(value) =>
        dispatch(setSelectedInternalEffect(value))
      }
    />
  )
}

export default PfmCrownInternalEffectPanel
